














































import Vue from 'vue'
import { Popover } from 'element-ui'
import './BackupOverview.scss'
import env from '../../env'
import { BackupOverview } from '@/types/ops'
import SubscribeBackupOverview from '@/mixins/SubscribeBackupOverview'

export default Vue.extend({
  name: 'BackupOverview',
  mixins: [ SubscribeBackupOverview ],
  computed: {
    summary (): BackupOverview {
      return this.$store.direct.state.opsmonitor.backupOverview
    },
    lastBackup (): string {
      const date = new Date(0)
      date.setUTCSeconds(this.summary.time)
      return date.toLocaleString()
    },
    backupSecondsAgo (): number {
      return (new Date()).getTime() / 1000 - this.summary.time
    },
    styles (): Partial<CSSStyleDeclaration> {
      return {
        color: this.backupSecondsAgo > 48 * 3600 ? 'var(--color-error)' : 'var(--color-success)'
      }
    },
    kenv (): string {
      return env.environment
    }
  },
  methods: {
    secToString (sec: number): string {
      let seconds = sec
      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor(seconds / 60 - hours * 60)
      seconds = Math.floor(seconds - minutes * 60 - hours * 3600)
      const secondsStr = (seconds < 10) ? `0${seconds}` : `${seconds}`
      const minutesStr = (minutes < 10) ? `0${minutes}` : `${minutes}`
      return `${hours}:${minutesStr}:${secondsStr}`
    }
  },
  components: {
    'el-popover': Popover
  }
})
